export const SearchIcon = ({ className = "ms-1", size = 10, fill="none" }) => (
    <svg className={className} width={size} height={size} viewBox="0 0 14 14" fill={fill}>
        <circle cx="6" cy="6" r="4.5" stroke="currentColor" strokeWidth="1.5" />
        <path d="M9.5 9.5L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
);